/** One grain of the cogent's sand, ready to draw: the orb's soft disc, whose alpha falls off as 1 - r^4. */
import { PALETTES } from './palette'

const SPRITE_PX = 16
/** The activation's spark: the sand catching fire for a moment. */
const EMBERS = [
  [1, 0.82, 0.22],
  [1, 0.62, 0.12],
  [0.95, 0.42, 0.08],
]

function grainSprite([red, green, blue]: number[]) {
  const sprite = document.createElement('canvas')
  sprite.width = sprite.height = SPRITE_PX
  const context = sprite.getContext('2d')!
  const image = context.createImageData(SPRITE_PX, SPRITE_PX)

  for (let y = 0; y < SPRITE_PX; y++)
    for (let x = 0; x < SPRITE_PX; x++) {
      const dx = ((x + 0.5) / SPRITE_PX) * 2 - 1
      const dy = ((y + 0.5) / SPRITE_PX) * 2 - 1
      const rr = dx * dx + dy * dy
      const at = (y * SPRITE_PX + x) * 4
      image.data[at] = red! * 255
      image.data[at + 1] = green! * 255
      image.data[at + 2] = blue! * 255
      image.data[at + 3] = rr > 1 ? 0 : (1 - rr * rr) * 255
    }

  context.putImageData(image, 0, 0)
  return sprite
}

let sand: HTMLCanvasElement[] | undefined
let embers: HTMLCanvasElement[] | undefined

export const sandSprites = () => (sand ??= PALETTES.blue.map(grainSprite))
export const emberSprites = () => (embers ??= EMBERS.map(grainSprite))
